import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon, BarsArrowUpIcon } from "@heroicons/react/24/solid";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import RefreshButton from "../../../components/RefreshButton";
import SearchButton from "../../../components/SearchButton";
import SelectInput from "../../../components/SelectInput";
import TextInput from "../../../components/TextInput";
import { useStates } from "../hooks/useStates";
import { useGetActiveOfficeBrand } from "../OfficeSettings/hooks/useGetActiveOfficeBrand";
import { useGetActiveOfficeStatus } from "../OfficeSettings/hooks/useGetActiveOfficeStatus";
import { useSFGetOffice } from "../OfficeSettings/hooks/useSFGetOffice";
import { securitySearchData } from "./atoms/atoms";
import useSearchSecurity from "./hooks/useSearchSecurity";

const TableFilters = ({
  isSearching,
  setIsSearching,
  setSearchedSecurity,
  setCaseNumberValue,
  setFilteredSecurity,
  setClearFilter,
  clearFilter,
  setReset,
  setIds,
}) => {
  const { mutate: SearchSecurity } = useSearchSecurity();
  const { data: agencies } = useSFGetOffice();
  const [recordNumber, setRecordNumber] = useState("");
  const [filteredSecurity, setFilteredData] = useState([]);
  const [searchInputsData, setSearchInputsData] =
    useRecoilState(securitySearchData);
  const [disableSearchButton, setDisableSearchButton] = useState(true);
  const { data: activeOfficeStatus } = useGetActiveOfficeStatus();

  const activeOfcStatus = activeOfficeStatus?.map((x) => {
    return {
      label: x.status,
      value: x.officeStatusId,
    };
  });

  const officeStatus = activeOfcStatus?.filter((x) => x.label !== "");
  useEffect(() => {
    if (clearFilter) {
      refreshSecurity();
    }
    setClearFilter(false);
  }, []);
  const sfOfficeNameOpt = agencies?.map((x) => {
    return {
      name: x.businessOperation,
      id: x.officeCode,
      value: x.officeId,
      label: x.officeName,
    };
  });
  const { data: officeBdata } = useGetActiveOfficeBrand();
  const activeOfficeBrand = [
    ...new Map(
      officeBdata?.map(item => [
        `${item.brandName} - ${item.state}`,
        item,
      ]) ?? []
    ).values(),
  ].map(resData => ({
    label: `${resData.brandName} - ${resData.state}`,
    value: `${resData.brandName} - ${resData.state}`,
    brandName: resData.brandName,
    state: resData.state,
    dba: resData.dba,
    usedInMexico: resData.usedInMexico,
  }));

  const officeBrand = activeOfficeBrand?.filter((x) => x.label !== "");
  const { data: states } = useStates();
  const stateOptions = states?.map((x) => {
    return {
      label: x.state,
      value: x.state,
    };
  });

  useEffect(() => {
    if (filteredSecurity.length > 0)
      setIds(filteredSecurity && filteredSecurity?.map((x) => x.recordNumber));
  }, [filteredSecurity]);

  //search field identifier
  useEffect(() => {
    if (searchInputsData.RecordNumber !== "") {
      setDisableSearchButton(false);
    } else if (searchInputsData.OfficeId !== null) {
      setDisableSearchButton(false);
    } else if (searchInputsData.OfficeStatus) {
      setDisableSearchButton(false);
    } else if (searchInputsData.OfficeBrand) {
      setDisableSearchButton(false);
    } else if (searchInputsData.OfficeState) {
      setDisableSearchButton(false);
    } else {
      setDisableSearchButton(true);
    }
  }, [searchInputsData]);
  const refreshSecurity = () => {
    setIds([]);
    setSearchedSecurity([]);
    setFilteredSecurity([]);
    setSearchInputsData({
      ...searchInputsData,
      RecordNumber: "",
      OfficeId: null,
      OfficeStatus: "",
      OfficeBrand: "",
      OfficeState: "",
    });
    setReset(true);
    setRecordNumber("");
  };
  useEffect(() => {
    if (setCaseNumberValue && isSearching) setRecordNumber(setCaseNumberValue);
  }, [isSearching, setCaseNumberValue]);

  return (
    <div className="pr-1 space-y-2 pt-2">
      <div class="pt-2">
        <BarsArrowUpIcon className="h-6 w-6 text-primary mb-1.5" />
        <div className="text-xl font-bold text-primary -mt-9 ml-8">
          Search Section
        </div>
      </div>
      <div className="w-full">
        <div className="w-full max-w-md mx-auto bg-white rounded-2xl">
          <Disclosure defaultOpen={isSearching}>
            {({ open }) => (
              <>
                <Disclosure.Button className="sm:px-2 flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-primary bg-gray-100 rounded-t-lg hover:bg-gray-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75">
                  <span>Security Details</span>
                  <ChevronDownIcon
                    className={`${
                      open ? "transform rotate-180" : ""
                    } w-5 h-5 text-gray-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="bg-gray-100 text-sm text-primary rounded-b-lg">
                  <div className="bg-gray-100  p-3 sm:px-2 md:px-3">
                    <div className="flex flex-col text-xs gap-x-4 gap-y-2">
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Security Number
                        </label>
                        <TextInput
                          name="recordNumber"
                          type="text"
                          value={
                            searchInputsData.RecordNumber
                              ? searchInputsData.RecordNumber
                              : recordNumber
                          }
                          onChange={(e) => {
                            setSearchInputsData({
                              ...searchInputsData,
                              RecordNumber: e.target.value,
                            });
                          }}
                          pattern={"([A-Z]{1}?)"}
                        />
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Office Name
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={sfOfficeNameOpt}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                OfficeId: e ? e.value : null,
                              });
                            }}
                            value={sfOfficeNameOpt?.filter(
                              (x) => x.value === searchInputsData.OfficeId
                            )}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Office State
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={stateOptions}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                OfficeState: e ? e.value : null,
                              });
                            }}
                            value={stateOptions?.filter(
                              (x) => x.value === searchInputsData.OfficeState
                            )}
                          />
                        </div>
                      </div>

                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Office Brand
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={officeBrand}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                OfficeBrand: e ? e.value : null,
                              });
                            }}
                            value={officeBrand?.filter(
                              (x) => x.value === searchInputsData.OfficeBrand
                            )}
                          />
                        </div>
                      </div>
                      <div className="w-full">
                        <label className="block font-medium text-gray-700 mb-2">
                          Office Status
                        </label>
                        <div className="w-full">
                          <SelectInput
                            options={officeStatus}
                            onChange={(e) => {
                              setSearchInputsData({
                                ...searchInputsData,
                                OfficeStatus: e ? e.label : null,
                              });
                            }}
                            value={officeStatus?.filter(
                              (x) => x.label === searchInputsData.OfficeStatus
                            )}
                          />
                        </div>
                      </div>

                      <div className="flex justify-center items-end gap-x-2 mb-12  lg:ml-4 md:ml-1 rounded-md mt-5">
                        <SearchButton
                          buttonValue="Search"
                          className={"opacity-100"}
                          disabled={disableSearchButton}
                          onClick={() => {
                            setReset(false);
                            SearchSecurity(
                              {
                                ...searchInputsData,
                              },
                              {
                                onSuccess: (res) => {
                                  setSearchedSecurity(res?.data);
                                  setFilteredData(res?.data);
                                },
                                onError: (error) => {
                                  //console.log("error", error);
                                },
                              }
                            );
                            setIsSearching(true);
                          }}
                        />
                        <RefreshButton
                          className={"opacity-100"}
                          disabled={false}
                          onClick={() => {
                            refreshSecurity();
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        </div>
      </div>{" "}
    </div>
  );
};

export default TableFilters;
